import Styled from 'styled-components'
import { maxQuery } from '../../../../helpers'

export default Styled.div`
    .loading-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 4em 1em;
        
        .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid rgba(255, 255, 255, 0.1);
            border-top-color: ${({ theme }) => theme.primary};
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            margin-bottom: 1em;
        }
        
        @keyframes spin {
            to { transform: rotate(360deg); }
        }
        
        p {
            color: rgba(255, 255, 255, 0.6);
            font-size: 1rem;
        }
    }

    .welcome-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2em;
        gap: 1em;
        
        ${maxQuery('md')} {
            flex-direction: column;
            align-items: flex-start;
        }
        
        h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #fff;
            margin: 0 0 0.5em 0;
            
            ${maxQuery('md')} {
                font-size: 1.5rem;
            }
        }
        
        p {
            font-size: 1rem;
            color: rgba(255, 255, 255, 0.7);
            margin: 0;
        }
        
        .primary-action-btn {
            display: flex;
            align-items: center;
            gap: 0.5em;
            padding: 0.875em 1.5em;
            background: ${({ theme }) => theme.primary};
            color: #fff;
            border: none;
            border-radius: 8px;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            
            &:hover {
                background: ${({ theme }) => theme.primaryHover || theme.primary};
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);
            }
            
            svg {
                font-size: 1rem;
            }
        }
    }
    
    .stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5em;
        margin-bottom: 2em;
        
        .stat-card {
            background: #272B4A;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-left: 4px solid;
            border-radius: 8px;
            padding: 1.5em;
            display: flex;
            gap: 1.5em;
            align-items: center;
            cursor: pointer;
            transition: all 0.2s;
            
            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                background: #2d3152;
            }
            
            .stat-icon {
                width: 60px;
                height: 60px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.5rem;
                flex-shrink: 0;
            }
            
            .stat-content {
                flex: 1;
                
                .stat-label {
                    font-size: 0.85rem;
                    color: rgba(255, 255, 255, 0.6);
                    margin: 0 0 0.5em 0;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                
                .stat-value {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #fff;
                    margin: 0 0 0.3em 0;
                    
                    ${maxQuery('md')} {
                        font-size: 1.5rem;
                    }
                }
                
                .stat-change {
                    font-size: 0.8rem;
                    color: rgba(255, 255, 255, 0.5);
                    margin: 0;
                }
            }
        }
    }
    
    .content-grid {
        display: grid;
        grid-template-columns: 1.5fr 1fr;
        gap: 1.5em;
        
        ${maxQuery('lg')} {
            grid-template-columns: 1fr;
        }
        
        .card {
            background: #272B4A;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            padding: 1.5em;
            
            &.recent-orders-card {
                ${maxQuery('lg')} {
                    order: 2;
                }
            }
            
            &.quick-actions-card {
                ${maxQuery('lg')} {
                    order: 1;
                }
            }
            
            .card-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 1.5em;
                padding-bottom: 1em;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                
                h3 {
                    font-size: 1.2rem;
                    font-weight: 600;
                    color: #fff;
                    margin: 0;
                }
                
                .view-all-btn {
                    background: transparent;
                    border: 1px solid ${({ theme }) => theme.primary};
                    color: ${({ theme }) => theme.primary};
                    padding: 0.5em 1em;
                    border-radius: 6px;
                    font-size: 0.85rem;
                    cursor: pointer;
                    transition: all 0.2s;
                    
                    &:hover {
                        background: ${({ theme }) => theme.primary};
                        color: #fff;
                    }
                }
            }
            
            h3 {
                font-size: 1.2rem;
                font-weight: 600;
                color: #fff;
                margin: 0 0 1.5em 0;
                padding-bottom: 1em;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
            
            .orders-list {
                display: flex;
                flex-direction: column;
                gap: 1em;
                max-height: 500px;
                overflow-y: auto;
                
                &::-webkit-scrollbar {
                    width: 6px;
                }
                
                &::-webkit-scrollbar-track {
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 3px;
                }
                
                &::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 3px;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.3);
                    }
                }
                
                .order-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    padding: 1em;
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.2s;
                    gap: 1em;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.06);
                        border-color: rgba(255, 255, 255, 0.15);
                        transform: translateX(3px);
                    }
                    
                    .order-info {
                        flex: 1;
                        min-width: 0;
                        
                        .order-tracking {
                            font-size: 0.9rem;
                            font-weight: 600;
                            color: ${({ theme }) => theme.primary};
                            margin: 0 0 0.4em 0;
                        }
                        
                        .order-customer {
                            font-size: 0.85rem;
                            color: rgba(255, 255, 255, 0.8);
                            margin: 0 0 0.3em 0;
                        }
                        
                        .order-address {
                            font-size: 0.8rem;
                            color: rgba(255, 255, 255, 0.5);
                            margin: 0;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                    
                    .order-meta {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        gap: 0.5em;
                        flex-shrink: 0;
                        
                        .status-badge {
                            padding: 0.3em 0.8em;
                            border-radius: 12px;
                            font-size: 0.75rem;
                            font-weight: 600;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                            white-space: nowrap;
                        }
                        
                        .order-time {
                            font-size: 0.75rem;
                            color: rgba(255, 255, 255, 0.4);
                            white-space: nowrap;
                        }
                    }
                }
                
                .empty-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 3em 1em;
                    color: rgba(255, 255, 255, 0.5);
                    
                    svg {
                        margin-bottom: 1em;
                        color: rgba(255, 255, 255, 0.3);
                    }
                    
                    p {
                        margin: 0 0 1em 0;
                        font-size: 0.9rem;
                    }
                    
                    .create-order-btn {
                        padding: 0.75em 1.5em;
                        background: ${({ theme }) => theme.primary};
                        color: #fff;
                        border: none;
                        border-radius: 6px;
                        font-size: 0.9rem;
                        font-weight: 600;
                        cursor: pointer;
                        transition: all 0.2s;
                        
                        &:hover {
                            background: ${({ theme }) => theme.primaryHover || theme.primary};
                        }
                    }
                }
            }
            
            .actions-list {
                display: flex;
                flex-direction: column;
                gap: 1em;
                
                .action-btn {
                    display: flex;
                    align-items: center;
                    gap: 1em;
                    padding: 1em;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 8px;
                    cursor: pointer;
                    transition: all 0.2s;
                    text-align: left;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.08);
                        border-color: rgba(255, 255, 255, 0.15);
                        transform: translateX(5px);
                    }
                    
                    .action-icon {
                        width: 48px;
                        height: 48px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 1.2rem;
                        flex-shrink: 0;
                    }
                    
                    .action-text {
                        display: flex;
                        flex-direction: column;
                        gap: 0.3em;
                        
                        .action-title {
                            color: rgba(255, 255, 255, 0.95);
                            font-size: 0.95rem;
                            font-weight: 600;
                        }
                        
                        .action-subtitle {
                            color: rgba(255, 255, 255, 0.5);
                            font-size: 0.8rem;
                        }
                    }
                }
            }
        }
    }
`
